/**
 * Base API Manager.
 */
export default class BaseApiManager {

  protected url
  protected axios

  /**
   * Constructor.
   *
   * @param {String} url
   */
  constructor (axios, url) {
    this.url = url
    this.axios = axios
  }

  /**
   * Find entity by ID.
   *
   * @param {Number} id
   *
   * @returns {Promise<void>}
   */
  async findById ({id}) {
    return await this.axios.get(`${this.url}/${id}`)
  }

  /**
   * Paginate all entities.
   *
   * @param {Number} perPage
   * @param {Number} page
   * @param {String} sort
   * @param {String} search
   * @returns {Promise<any>}
   */
  async paginateAll (perPage, page, sort, search) {
    return await this.axios.get(`${this.url}`, {
      params: {
        perPage,
        page,
        sort,
        search,
      },
    })
  }

  /**
   * Search all entities.
   *
   * @param {String} search
   * @param {Number} perPage
   * @param {Number} page
   *
   * @returns {Promise<any>}
   */
  async search (search = '', perPage = 10, page = 1) {
    return await this.axios.get(`${this.url}`, {
      params: {
        search,
        perPage,
        page,
      },
    })
  }

  /**
   * Delete Curator by ID.
   *
   * @param {Number} id
   *
   * @returns {Promise<void>}
   */
  async deleteById (id) {
    return await this.axios.delete(`${this.url}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/api/managers/BaseApiManager.ts